module.exports = __webpack_public_path__ + "assets/img/mecha-52b61904.png";